<template>
  <svg
    width="202"
    height="195"
    viewBox="0 0 202 195"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_1_603"
      style="mask-type:alpha"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="202"
      height="195"
    >
      <rect width="202" height="195" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_1_603)">
      <path
        d="M101 178.953C98.7557 178.953 96.6165 178.547 94.5824 177.734C92.5484 176.922 90.6897 175.771 89.0064 174.281L21.4626 109.078C19.9196 107.453 18.7272 105.659 17.8855 103.695C17.0439 101.732 16.623 99.6664 16.623 97.4998C16.623 95.3331 17.0439 93.2341 17.8855 91.2029C18.7272 89.1716 19.9196 87.4112 21.4626 85.9216L89.0064 20.7185C90.6897 19.0935 92.5484 17.9086 94.5824 17.1638C96.6165 16.419 98.7557 16.0466 101 16.0466C103.245 16.0466 105.419 16.419 107.523 17.1638C109.627 17.9086 111.451 19.0935 112.994 20.7185L180.538 85.9216C182.221 87.4112 183.448 89.1716 184.22 91.2029C184.991 93.2341 185.377 95.3331 185.377 97.4998C185.377 99.6664 184.991 101.732 184.22 103.695C183.448 105.659 182.221 107.453 180.538 109.078L112.994 174.281C111.451 175.771 109.627 176.922 107.523 177.734C105.419 178.547 103.245 178.953 101 178.953ZM101 162.703L168.544 97.4998L101 32.2966L33.4564 97.4998L101 162.703ZM92.5835 105.625H109.417V56.8748H92.5835V105.625ZM101 130C103.385 130 105.384 129.221 106.997 127.664C108.61 126.107 109.417 124.177 109.417 121.875C109.417 119.573 108.61 117.643 106.997 116.086C105.384 114.528 103.385 113.75 101 113.75C98.6154 113.75 96.6165 114.528 95.0033 116.086C93.3901 117.643 92.5835 119.573 92.5835 121.875C92.5835 124.177 93.3901 126.107 95.0033 127.664C96.6165 129.221 98.6154 130 101 130Z"
        fill="#FFCA0D"
      />
    </g>
  </svg>
</template>

<script>
export default {
  name: "IconWarning",
};
</script>

<style lang="scss" scoped></style>
